import React from 'react'
import "../Styles/Footer.css"

function Footer() {
    return (
        <div id="footer">
            <a href="https://github.com/Pratyush-exe/ReDD-AI/" id="footer-line" target="_blank">Coded with ❤️</a>
        </div>
    )
}

export default Footer
